import styled from 'styled-components'

export const THead = styled.thead``
THead.defaultProps = { role: 'rowgroup' } 